'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _IconButton = require('@material-ui/core/IconButton');
var _IconButton2 = _interopRequireDefault(_IconButton);
var _Add = require('@material-ui/icons/Add');
var _Add2 = _interopRequireDefault(_Add);
var _Remove = require('@material-ui/icons/Remove');
var _Remove2 = _interopRequireDefault(_Remove);
require('medium-editor/dist/css/medium-editor.css');
require('medium-editor/dist/css/themes/bootstrap.css');
var _reactMediumEditor = require('react-medium-editor');
var _reactMediumEditor2 = _interopRequireDefault(_reactMediumEditor);
var _backgrounds = require('../../helpers/backgrounds');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  ExpandableRow: {
    position: function position(_ref) {
      var editable = _ref.editable;
      return !editable && 'relative';
    },
    width: '100%'
  },
  title: {
    padding: '1rem 2em',
    color: function color(_ref2) {
      var titleColor = _ref2.otherProperties.titleColor;
      return titleColor;
    },
    fontSize: function fontSize(_ref3) {
      var responsiveMode = _ref3.responsiveMode,
        _ref3$otherProperties = _ref3.otherProperties,
        titleFontSize = _ref3$otherProperties.titleFontSize,
        mobileTitleFontSize = _ref3$otherProperties.mobileTitleFontSize;
      return responsiveMode === _ResponsiveModes.MOBILE ? mobileTitleFontSize : titleFontSize;
    },
    '& .text': {
      outline: 0,
      minHeight: 'initial',
      textAlign: 'center',
      '& p, & h1, & h2': {
        margin: 0,
        wordWrap: 'break-word'
      }
    }
  },
  iconButton: {
    position: 'absolute',
    right: '0.25rem',
    top: '0.25rem',
    color: function color(_ref4) {
      var buttonColor = _ref4.otherProperties.buttonColor;
      return buttonColor;
    },
    width: 'auto',
    height: 'auto',
    pointerEvents: function pointerEvents(_ref5) {
      var editable = _ref5.editable;
      return editable && 'none';
    }
  },
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    padding: '0.25rem'
  },
  content: {
    display: 'none',
    flexWrap: 'wrap',
    width: '100%',
    '&.expanded': {
      display: 'flex'
    }
  }
};
var ExpandableRow = function (_Component) {
  _inherits(ExpandableRow, _Component);
  function ExpandableRow(props) {
    _classCallCheck(this, ExpandableRow);
    var _this = _possibleConstructorReturn(this, (ExpandableRow.__proto__ || Object.getPrototypeOf(ExpandableRow)).call(this, props));
    _this.toggleExpanded = function () {
      return _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    };
    _this.state = {
      expanded: props.otherProperties.expandedByDefault
    };
    return _this;
  }
  _createClass(ExpandableRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        children = _props.children,
        value = _props.value,
        editable = _props.editable,
        onChangeText = _props.onChangeText,
        responsiveMode = _props.responsiveMode;
      var backgroundImage = cssProperties.backgroundImage;
      var expanded = this.state.expanded;
      var processedStyle = _extends({}, cssProperties, {
        backgroundImage: (0, _backgrounds.wrapWithUrl)(backgroundImage, responsiveMode)
      });
      var options = {
        buttonLabels: 'fontawesome',
        toolbar: {
          buttons: ['bold', 'italic', 'underline', 'h1', 'h2']
        }
      };
      return _react2.default.createElement('div', {
        className: classes.ExpandableRow,
        style: processedStyle
      }, _react2.default.createElement('div', {
        className: classes.title
      }, editable ? _react2.default.createElement(_reactMediumEditor2.default, {
        className: 'text',
        text: value,
        options: options,
        onChange: onChangeText
      }) : _react2.default.createElement('div', {
        className: 'text',
        dangerouslySetInnerHTML: {
          __html: value
        }
      }), _react2.default.createElement(_IconButton2.default, {
        onClick: this.toggleExpanded,
        className: classes.iconButton,
        'aria-label': (expanded ? 'contract' : 'expand') + ' content'
      }, expanded ? _react2.default.createElement(_Remove2.default, {
        classes: {
          root: classes.icon
        }
      }) : _react2.default.createElement(_Add2.default, {
        classes: {
          root: classes.icon
        }
      }))), _react2.default.createElement('div', {
        className: classes.content + ' ' + (editable || expanded ? 'expanded' : '')
      }, children));
    }
  }]);
  return ExpandableRow;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(ExpandableRow);